var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWindows2Line = function SvgWindows2Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#windows-2-line_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1 3.9a.9.9 0 0 1 .9.9v7.8h-1.8v-1.5H4.8v7.2h8.624v1.8H3.9a.9.9 0 0 1-.9-.9V4.8a.9.9 0 0 1 .9-.9zM4.8 9.3h14.4V5.7H4.8zm13.5-.9h-3.6V6.6h3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.132 17.147a4.952 4.952 0 0 1 9.737 0 4.952 4.952 0 0 1-9.737 0M19 19.397a2.25 2.25 0 1 0 0-4.501 2.25 2.25 0 0 0 0 4.5Zm0-.9a1.35 1.35 0 1 1 0-2.701 1.35 1.35 0 0 1 0 2.7Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "windows-2-line_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgWindows2Line;